import { ethers } from 'ethers'

import { tokenAbi } from '../../utils/config'

export async function readErc20Metadata(provider, address) {
    const code = await provider.getCode(address)
    if (!code || code === '0x') {
        const error = new Error('PAYMENT_TOKEN_NOT_CONTRACT')
        error.code = 'PAYMENT_TOKEN_NOT_CONTRACT'
        throw error
    }

    const contract = new ethers.Contract(address, tokenAbi, provider)
    const [name, symbol, decimals] = await Promise.all([
        contract.name(),
        contract.symbol(),
        contract.decimals(),
    ])

    return {
        address: ethers.utils.getAddress(address),
        name,
        symbol,
        decimals: Number(decimals.toString()),
    }
}
